import { makeApi } from "@zodios/core";
import { z } from "zod";

import { activateProgramRequestSchema } from "@/data/api/kili/programs/program.type";

export const internalApi = makeApi([
  {
    method: "post",
    path: "/programs/:programId/activate",
    response: z.unknown(), // 200
    alias: "activateProgram",
    parameters: [
      {
        type: "Body",
        name: "body",
        schema: activateProgramRequestSchema,
      },
      {
        type: "Path",
        name: "programId",
        schema: z.number(),
      },
    ],
  },
  {
    method: "delete",
    path: "/programs/:programId/",
    response: z.unknown(), // 200
    alias: "deleteProgram",
    parameters: [
      {
        type: "Path",
        name: "programId",
        schema: z.number(),
      },
    ],
  },
]);
